<div class="row">
    <div class="col-1"></div>
    <div class="col-10 goldbar d-flex justify-content-center">
        ______________________________________________________________________________
    </div>
</div>